var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pix-member-circle-row" },
    [
      _vm._l(_vm.initialNames, function (name, index) {
        return _c("pix-member-circle", {
          key: `${name}${index}`,
          attrs: { name: name, clickable: _vm.clickable },
          on: {
            click: function ($event) {
              return _vm.emitClick(name)
            },
          },
        })
      }),
      _vm._v(" "),
      _vm.exceedsNamesLimit
        ? _c(
            "div",
            {
              staticClass: "pix-member-circle-row__wrapper",
              on: {
                mouseenter: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showMenu = true
                },
                mouseleave: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showMenu = false
                },
              },
            },
            [
              _c("pix-member-circle", {
                attrs: {
                  dummy: "",
                  "dummy-text": `+${_vm.exceedingNames.length}`,
                  clickable: _vm.clickable,
                },
              }),
              _vm._v(" "),
              _vm.showMenu
                ? _c(
                    "div",
                    { staticClass: "pix-member-circle-row__wrapper__menu" },
                    [
                      _c(
                        "ul",
                        _vm._l(
                          _vm.exceedingNames,
                          function (exceedingName, exceedingNameIndex) {
                            return _c(
                              "li",
                              {
                                key: `${exceedingName}${exceedingNameIndex}`,
                                class: `
                          pix-member-circle-row__wrapper__menu__item
                          ${
                            _vm.clickable
                              ? "pix-member-circle-row__wrapper__menu__item--clickable"
                              : ""
                          }
                      `,
                                attrs: {
                                  title: _vm.getFormattedName(exceedingName),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.emitClick(exceedingName)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getFormattedName(exceedingName))
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }